import React from "react";
import { Bubble } from "react-chartjs-2";
import { Box, Paper } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
ChartJS.register({
  id: "customSpacingLegend",
  beforeInit(chart) {
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;

    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height += 15;
    };
  },
});
export default function BasicStatsChart(props) {
  const { priamryPlayerData, groupAvg, chartName, name } = props;
  var popData = {
    datasets: [
      {
        label: [name],
        data: priamryPlayerData,
        backgroundColor: "Red",
      },
      {
        label: ["Comparison Group"],
        data: groupAvg,
        backgroundColor: "Blue",
      },
    ],
  };
  const formatter = new Intl.NumberFormat("fr");
  return (
    <Box mt={2} mb={2}>
      <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5" }}>
        <Box sx={{ maxWidth: "400px", maxHeight: "400px" }}>
          <div style={{ textAlign: "center" }}>
            <h3>{chartName}</h3>
          </div>

          <Bubble
            data={popData}
            options={{
              plugins: {
                tooltip: {
                  callbacks: {
                    label: function (data) {
                      var label =
                        data.label +
                        "(" +
                        data.parsed.x +
                        "," +
                        data.parsed.y +
                        ")";
                      return label;
                    },
                  },
                },
              },
              scales: {
                xAxes: {
                  grid: {
                    color: "black",
                  },
                  ticks: {
                    color: "black",
                    // stepSize: 0.1
                  },
                  scaleLabel: {
                    lableString: "Chart Name",
                    display: true,
                  },
                },
                yAxes: {
                  grid: {
                    color: "black",
                  },
                  ticks: {
                    color: "black",
                    stepSize: 1,
                    callback: function (value, index, values) {
                      return formatter.format(value);
                    },
                  },
                },
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
}
